import { CLASSES } from '../utils/constants';
import { toggleHtmlClass } from '../utils/domHelpers';

export function applyBoldText(enabled) {
  toggleHtmlClass(CLASSES.boldText, enabled);
}
